export const queryStringGenerator = (payload: any) => {
  if (
    payload &&
    typeof payload === "object" &&
    Object.keys(payload).length > 0
  ) {
    return (
      "?" +
      Object.keys(payload)
        .map((key) => `${key}=${payload[key]}`)
        .join("&")
    );
  } else {
    return "";
  }
};
